// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"b621a154","276":"49a7c660","310":"d5c4fcf7","423":"e0c3e20d","626":"08a120ea","732":"b5e5bb6d","767":"5d43b70c","835":"686c0713","911":"c9966c07"}[chunkId] + ".chunk.js";
};